import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { Button } from "./Button/Button"; // Assuming Button is in ./Button relative to this file
import styles from "./DeprecatedFeatureCard.module.css";

interface DeprecatedFeatureCardProps {
  moduleName: string;
  redirectUrl: string;
  helpCenterUrl: string;
}

const DeprecatedFeatureCard: React.FC<DeprecatedFeatureCardProps> = ({
  moduleName,
  redirectUrl,
  helpCenterUrl,
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.card}>
      <div className={styles.content}>
        <div className={styles.title}>
          {t("deprecation.titleNewVersionAvailable", { moduleName })}
        </div>
        <p className={styles.description}>
          <Trans i18nKey="deprecation.content" values={{ moduleName }}>
            A new version of
            <span>{{ moduleName }}</span>
            is now available. Please click the button below to switch to the
            latest version and enjoy a more streamlined user experience with
            enhanced capabilities in SleekFlow 2.0. For any questions or issues
            during the transition, please visit our
            <a href={helpCenterUrl} target="_blank" rel="noopener noreferrer">
              Help Center
            </a>
            for more details or contact our support team.
          </Trans>
        </p>
        <div className={styles.buttonContainer}>
          <Button
            primary
            customSize="input"
            onClick={() => (window.location.href = redirectUrl)}
          >
            {t("deprecation.button.redirect")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DeprecatedFeatureCard;
